import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { useRouter } from '@/hooks';
import * as state from '@/state';
import { abyssColors } from '@/theme/colors';
import { MoreVert } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { StyledButtonMenu } from './styles';
import { useGetStructureId } from '@/hooks/useGetStructureId';

export type ZoneMenuRef = {
  handleClose: () => void;
};

export const ZoneMenu = ({ zoneId }: { zoneId: string }) => {
  const setSelectedZone = useSetAtom(state.selectedZone);
  const allZones = useAtomValue(state.zones);
  const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>(undefined);
  const mainRef = useRef(null);
  const router = useRouter();
  const structureId = useGetStructureId();

  const handleMenuClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAnchorElement(mainRef.current ?? undefined);
  };

  const handleClose = () => {
    setAnchorElement(undefined);
  };

  const handleView3D = (event: React.MouseEvent) => {
    event.stopPropagation();
    const selectedZone = allZones.find((zone) => zone.id === zoneId);
    if (selectedZone) {
      setSelectedZone(selectedZone);
      router.push(`/asset-labelling/${structureId}/viewer`);
    }
  };

  return (
    <>
      <IconButton ref={mainRef} onClick={handleMenuClick} sx={{ padding: 0 }} disableRipple>
        <MoreVert sx={{ color: abyssColors.primary[500], fontSize: '1.8rem' }} />
      </IconButton>

      <StyledButtonMenu
        elevation={0}
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleView3D}>
          <AbyssIcon iconName="cube-secondary" style={{ width: '1.4rem', height: '1.4rem' }} />
          <span>View 3D</span>
        </MenuItem>
      </StyledButtonMenu>
    </>
  );
};
